import { useState, useEffect } from 'react';
import { HostBackend } from '../../../../Routes/HostBackend.js';
/* document */
import { Text } from '../../Form/Inputs/Text.js';
import { Date } from '../../Form/Inputs/Date.js';
import { Select } from '../../Form/Inputs/Select.js';
import { Hidden } from '../../Form/Inputs/Hidden.js';

export const Park = (props) => {
    const { el } = props;
    const backend = HostBackend();
    const token = sessionStorage.getItem('token');
    const [choosers, setChoosers] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasChoosers = await fetch(`${backend}/admin/choosers/park`, {
                method: 'GET', headers: { 'Authorization': token, 'Content-Type': 'application/json' }
            });
            const choosers = await datasChoosers.json();
            setChoosers(choosers);
        };
        fetchData();
    }, [backend, token]);
    return (
        <>
            <Text name="name" value={el ? el.name : ''} />
            <Text name="slug" value={el ? el.slug : ''} />
            <Text name="route" value={el ? el.route :''} />
            <Date name="created" value={el ? el.created : ''} />
            <Text name="author" value={el ? el.author : ''} />
            <Select name="id_description" choosers={choosers.describe} value={el ? el.id_description : ''} />
            <Hidden name="id" value={el ? el.id : ''} />
        </>
    )
}